var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between"},[_c('span',[_vm._v(_vm._s(_vm.startTime))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.endTime))])]),_c('div',{ref:"slider"})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }